module.exports = __webpack_public_path__ + "static/img/btn_app_android.7e78463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_app_android.png
// module id = GJv8
// module chunks = 0